module.exports = __webpack_public_path__ + "static/media/fccPointsLogo.981976e4.svg";